import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import PassResultType from "../enums/pass-result-type";
import BrokenUpByPositionPref from "./position-pref/broken-up-by-position-pref";

export default class PassIncomplete extends Fragment {
    constructor(intendedFor, brokenUpBy) {
        super();

        this.intendedFor = intendedFor;
        this.brokenUpBy = brokenUpBy;
        this.passResultCode = PassResultType.INCOMPLETE.code;

        this.requiredData = [
            {
                name: "intendedFor",
                type: FragmentDataType.Player,
                displayName: "Intended for",
                title: (team) => `Intended for: ${team.teamName}`,
                subtitle: "Select a player or enter player uniform",
                isEditable: true
            },
            {
                name: "brokenUpBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Broken up by",
                title: (team) => `Broken up by: ${team.teamName}`,
                subtitle: "Select a player or enter player uniform",
                isEditable: true,
                optional: true,
                positionPref: (play) =>
                    new BrokenUpByPositionPref(play, this).resolve()
            }
        ];
    }

    getPlayers() {
        return [this.intendedFor, this.brokenUpBy].filter((p) => p?.id);
    }

    summarize(summaryContext, stringifier) {
        const intendedFor = stringifier.firstInitial(this.intendedFor);
        const brokenUpBy = this.brokenUpBy?.id
            ? ` (${stringifier.firstInitial(this.brokenUpBy)})`
            : "";

        return new FragmentSummary(`incomplete to ${intendedFor}${brokenUpBy}`);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            intendedFor: playerReducer(this.intendedFor),
            brokenUpBy: playerReducer(this.brokenUpBy)
        };
    }
}
